module.exports = __webpack_public_path__ + "img/bus-area-03.efc1be26.png";